import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { ErrorMessage } from "formik";
import { Wrapper, Input, Error } from "./styles/text-field-styles";

interface Props {
  field: unknown;
  form: unknown;
  isError: boolean;
  name: string;
  value?: string;
  error: string;
}

const TextField: FunctionComponent<Props> = ({ field, ...props }) => {
  const { error, name, value } = props;

  return (
    <Wrapper className="input-wrapper">
      <Input {...field} {...props} spellCheck={false} value={value} />
      <Error aria-label={error} className="error-message">
        <ErrorMessage name={name} />
      </Error>
    </Wrapper>
  );
};

TextField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  field: PropTypes.shape({}),
};

TextField.defaultProps = {
  value: null,
  error: null,
  field: null,
};

export default TextField;
